import type { App } from 'vue';
import type { Router } from 'vue-router';
import keepAliveVue3 from 'keep-alive-vue3';
import { createRouter, createWebHistory } from 'vue-router';
import routes from '@/router/routes';
import setupRouterGuard from '@/router/guard';
import useMatestoreStore from '@/store/matestoreStore';
import MicroComponent from '@/views/micro/index.vue';
let router: Router;

export function addMicroAppRoutes(option: any, parent?: string) {
  if (!router.hasRoute(option.name)) {
    const route = {
      path: option.path,
      name: option.name,
      meta: {
        isMicro: true,
      },
      component: MicroComponent,
    };
    if (parent) {
      const parentRoute = router.getRoutes().find((i) => i.name === parent);
      if (!parentRoute) {
        return;
      }
      router.addRoute(parent, route);
    } else {
      router.addRoute(route);
    }
  }
}

export function setupRouter(app: App<Element>, { base }) {
  router = createRouter({
    history: createWebHistory(base),
    routes: [...routes],
  });
  const matestoreStore = useMatestoreStore();
  for (const item of matestoreStore?.microMenu) {
    if (item.name === 'im') {
      continue;
    }
    addMicroAppRoutes(item);
  }
  for (const item of matestoreStore?.dashboardMicroApps) {
    addMicroAppRoutes(item, 'dashboard');
  }
  setupRouterGuard(router);
  app.use(router).use(keepAliveVue3);

  return router;
}

export const getVueRouter = () => {
  return router;
};
